<div [ngClass]="{ column: isColumnView, containerMobile: isMobile }" class="container">
  @if (!isColumnView) {
    <div class="typeWrapper">
      @if (!isSet && cargoSpace.type === 1) {
        <gl-icon
          [name]="'type-truck'"
          class="typeIcon"
        ></gl-icon>
      }
      @if (isSet && cargoSpace.type === 1) {
        <gl-icon
          [class.iconDeactive]="!isSecondCargoSpace()"
          [name]="'trailer'"
          class="trailerIcon"
        ></gl-icon>
      }
      @if (isSet && cargoSpace.type === 1) {
        <gl-icon
          [class.iconDeactive]="isSecondCargoSpace()"
          [name]="'semi-trailer'"
          class="semiTrailerIcon"
        ></gl-icon>
      }
      @if (cargoSpace.type === 2) {
        <gl-icon [name]="'type-container'" class="typeIcon"></gl-icon>
      }
      @if (cargoSpace.type === 3) {
        <gl-icon [name]="'type-other'" class="typeIcon"></gl-icon>
      }
    </div>
  }

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'loaded-loads'" class="elementIcon"></gl-icon>
    </div>
    @if (!isColumnView) {
      <div [glTooltip]="'loaded_loads'" [position]="'top'" class="valueWrapper">
        <span class="value-description"> {{ 'loaded_loads_acronym' | translate }}: </span>
        <span class="value">
          {{ summary.loadedLoads }}
        </span>
      </div>
    }
    @if (isColumnView) {
      <div class="valueWrapper">
        <span class="value-description"> {{ 'loaded_loads' | translate }}: </span>
        <span class="value">
          {{ summary.loadedLoads }}
        </span>
      </div>
    }
  </div>

  @if (replicatedLoadTotal() != null) {
    <div class="summaryElement" data-ctx="label-replicated-load-total">
      <div class="valueWrapper">
        <span class="value-description">Σ:</span>
        <span class="value">{{ replicatedLoadTotal() }}</span>
      </div>
    </div>
  }

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'loads-not-fit'" class="elementIcon"></gl-icon>
    </div>
    @if (!isColumnView) {
      <div [glTooltip]="'not_loaded_loads'" [position]="'top'" class="valueWrapper">
        <span class="value-description"> {{ 'not_loaded_loads_acronym' | translate }}: </span>
        <span class="value">
          @if (isAnyNotLoadedLoads()) {
            <span>{{ summary.notLoadedLoads }}</span>
          }
          @if (!isAnyNotLoadedLoads()) {
            <span>-</span>
          }
        </span>
      </div>
    }
    @if (isColumnView) {
      <div class="valueWrapper">
        <span class="value-description"> {{ 'not_loaded_loads' | translate }}: </span>
        <span class="value">
          @if (isAnyNotLoadedLoads()) {
            <span>{{ summary.notLoadedLoads }}</span>
          }
          @if (!isAnyNotLoadedLoads()) {
            <span>-</span>
          }
        </span>
      </div>
    }
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'weight-total'" class="elementIcon"></gl-icon>
    </div>
    @if (!isColumnView) {
      @if (!isTotalWeightOverLimit()) {
        <div
          [glTooltip]="'sum_of_loads_weight'"
          [position]="'top'"
          class="valueWrapper"
          >
          <span class="value-description"> {{ 'sum_of_loads_weight_acronym' | translate }}: </span>
          <span class="value">
            {{ summary.totalWeight | unit: 'weight':false }}
          </span>
        </div>
      }
    }
    @if (isColumnView) {
      @if (!isTotalWeightOverLimit()) {
        <div class="valueWrapper">
          <span class="value-description"> {{ 'sum_of_loads_weight' | translate }}: </span>
          <span class="value">
            {{ summary.totalWeight | unit: 'weight':false }}
          </span>
        </div>
      }
    }

    @if (!isColumnView) {
      @if (isTotalWeightOverLimit()) {
        <div
          #weightError
          [glTooltip]="'error_weight_over_limit'"
          [isError]="true"
          [position]="'top'"
          class="valueWrapper error"
          >
          <span class="value-description"> {{ 'sum_of_loads_weight_acronym' | translate }}: </span>
          <span class="value">
            {{ summary.totalWeight | unit: 'weight':false }}
          </span>
        </div>
      }
    }
    @if (isColumnView) {
      @if (isTotalWeightOverLimit()) {
        <div #weightError class="valueWrapper error">
          <span class="value-description"> {{ 'sum_of_loads_weight' | translate }}: </span>
          <span class="value">
            {{ summary.totalWeight | unit: 'weight':false }}
          </span>
        </div>
      }
    }
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'space'" class="elementIcon"></gl-icon>
    </div>
    @if (!isColumnView) {
      <div [glTooltip]="'free_space'" [position]="'top'" class="valueWrapper">
        <span class="value-description"> {{ 'free_space_acronym' | translate }}: </span>
        <span class="value">
          {{ summary.freeArea }} {{ getAreaAndVolumeUnit() }}<span class="superscript">2</span>
        </span>
      </div>
    }
    @if (isColumnView) {
      <div class="valueWrapper">
        <span class="value-description"> {{ 'free_space' | translate }}: </span>
        <span class="value">
          {{ summary.freeArea }} {{ getAreaAndVolumeUnit() }}<span class="superscript">2</span>
        </span>
      </div>
    }
  </div>

  <div class="summaryElement">
    <div class="iconWrapper">
      <gl-icon [name]="'used-volume'" class="elementIcon"></gl-icon>
    </div>
    @if (!isColumnView) {
      @if (cargoSpace.type !== 2) {
        <div
          [glTooltip]="'loads_summary_volume'"
          [position]="'top'"
          class="valueWrapper"
          >
          <span class="value-description"> {{ 'loads_volume_acronym' | translate }}: </span>
          <span class="value">
            {{ summary.occupiedVolume }}/{{ summary.totalVolume }} {{
            getAreaAndVolumeUnit()
            }}<span class="superscript">3</span>
          </span>
        </div>
      }
    }
    @if (isColumnView) {
      @if (cargoSpace && cargoSpace.type !== 2) {
        <div class="valueWrapper">
          <span class="value-description"> {{ 'loads_volume' | translate }}: </span>
          <span class="value">
            {{ summary.occupiedVolume }}/{{ summary.totalVolume }} {{
            getAreaAndVolumeUnit()
            }}<span class="superscript">3</span>
          </span>
        </div>
      }
    }
    @if (!isColumnView) {
      @if (cargoSpace && cargoSpace.type === 2) {
        <div
          [glTooltip]="calculateCBM()"
          [position]="'top'"
          class="valueWrapper"
          >
          <span class="value-description"> {{ 'loads_volume_acronym' | translate }}: </span>
          <span class="value"> {{ summary.occupiedVolume }} {{ 'CBM' }} </span>
        </div>
      }
    }
    @if (isColumnView) {
      @if (cargoSpace && cargoSpace.type === 2) {
        <div class="valueWrapper">
          <span class="value-description"> {{ 'loads_volume' | translate }}: </span>
          <span class="value"> {{ summary.occupiedVolume }} {{ 'CBM' }} </span>
        </div>
      }
    }
  </div>

  <!--    [ngClass]="{-->
  <!--      borderRight: cargoSpace && cargoSpace.frontAxi && !isColumnView,-->
  <!--      bottomMargin: cargoSpace && !cargoSpace.frontAxi-->
  <!--    }"-->
  @if (showLdm()) {
  <div
    [glTooltip]="totalLDMTooltip()"
    class="ldmWrapper"
    >
    <div class="valueWrapper">
      <span class="value-description"> {{ 'ldm_taken' | translate }}: </span>
      <span class="value">
        {{ summary.takenLdm }}
      </span>
    </div>
    <div
      [style.background]="
        'linear-gradient(90deg, #1CB9FC ' +
        calculateLineWidthPercentage() +
        '%' +
        ', #67FCAC ' +
        calculateLineWidthPercentage(5) +
        '%' +
        ')'
      "
      class="ldm-line"
    ></div>
    <div class="valueWrapper">
      <span class="value-description"> {{ 'ldm_free' | translate }}: </span>
      <span class="value">
        {{ summary.freeLdm }}
      </span>
    </div>
  </div>
  }

  @if (summary.axis?.length > 0) {
    <div class="axisWrapper">
      <div class="axisBorderWrapper">
        @for (axi of summary.axis; track axi; let index = $index) {
          <div class="axisContainer">
            <div class="axisElement">
              <div [glTooltip]="axiTooltip(index)" [position]="'top'" class="axisElement">
                <div class="valueWrapper">
                  <gl-icon [name]="'axle'" class="axleIcon"></gl-icon>
                  <span class="value-description"> {{index + 1}}</span>
                </div>
                <div
              [style.background]="
              'linear-gradient(90deg, #1CB9FC ' +
              calculateAxiLineWidthPercentage(index) +
              '%' +
              ', #67FCAC ' +
              calculateAxiLineWidthPercentage(index, 10) +
              '%' +
              ')'
            "
                  class="axisLine"
                ></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
